import { queryOptions, skipToken } from '@tanstack/react-query'

import { publicationApi } from '../../api/publicationApi'

export const publicationOptions = (id?: number) =>
  queryOptions({
    queryKey: ['publication', id],
    enabled: !!id,
    queryFn: id ? ({ signal }) => publicationApi.getPublication(id, { signal }) : skipToken,
    retry: 1,
  })
